import { singOut } from "../../store/slices/userSlice";
import store from "../../store/store";

import { connector } from "../../utils/common/connector";
const controller = "roles";

export const getRolesMaintenanceService = async (params) => {
  //user,
  //companyId,
  //page,
  //search,
  //pageSize

  const json = await connector.get(controller, "GetRolesMaintenance", params);

  return {
    roles: json?.roles ?? [],
    totalRoles: json?.totalRecords ?? 0,
  };

  //const baseApi = process.env.REACT_APP_API_BASE;

  //const options = {
  //    method: "GET", // specifying the HTTP method
  //    headers: {
  //        "Content-Type": "application/json", // specifying the Content-Type of the request body
  //        Authorization: `Bearer ${user?.token}`,
  //    },
  //};

  //const response = await fetch(
  //    `${baseApi}roles/getRoles?companyId=${companyId}&page=${page}&pageSize=${pageSize}&search=${search}`,
  //    options
  //).then((response) => response.json());

  //const json = await response;

  //if (json?.token === false) {
  //    store.dispatch(singOut());
  //    return {
  //        roles: [],
  //        totalRoles: 0,
  //    };
  //}

  //return {
  //    roles: json?.roles ?? [],
  //    totalRoles: json?.totalRecords ?? 0,
  //};
};

export const getRolesByCompanyService = async (params) => {
  //user,
  //companyId,
  //page,
  //search,
  //pageSize

  const json = await connector.get(controller, "GetRoles", params);

  return {
    roles: json?.roles ?? [],
    totalRoles: json?.totalRecords ?? 0,
  };

  //const baseApi = process.env.REACT_APP_API_BASE;

  //const options = {
  //    method: "GET", // specifying the HTTP method
  //    headers: {
  //        "Content-Type": "application/json", // specifying the Content-Type of the request body
  //        Authorization: `Bearer ${user?.token}`,
  //    },
  //};

  //const response = await fetch(
  //    `${baseApi}roles/getRoles?companyId=${companyId}&page=${page}&pageSize=${pageSize}&search=${search}`,
  //    options
  //).then((response) => response.json());

  //const json = await response;

  //if (json?.token === false) {
  //    store.dispatch(singOut());
  //    return {
  //        roles: [],
  //        totalRoles: 0,
  //    };
  //}

  //return {
  //    roles: json?.roles ?? [],
  //    totalRoles: json?.totalRecords ?? 0,
  //};
};

export const getRoleById = async (user, roleId) => {
  const baseApi = process.env.REACT_APP_API_BASE;

  const options = {
    method: "GET", // specifying the HTTP method
    headers: {
      "Content-Type": "application/json", // specifying the Content-Type of the request body
      Authorization: `Bearer ${user?.token}`,
    },
  };

  const response = await fetch(
    `${baseApi}roles/getRoleById?roleId=${roleId}`,
    options,
  ).then((response) => response.json());

  const json = await response;

  if (json?.token === false) {
    store.dispatch(singOut());
    return {
      role: {},
    };
  }

  return json;
};

export const createRole = async (user, data, companyId) => {
  const baseApi = process.env.REACT_APP_API_BASE;

  const options = {
    method: "POST", // specifying the HTTP method
    headers: {
      "Content-Type": "application/json", // specifying the Content-Type of the request body
      Authorization: `Bearer ${user?.token}`,
    },
    body: JSON.stringify({
      data: {
        ...data,
        companyId,
      },
    }),
  };

  const response = await fetch(`${baseApi}roles/create`, options).then(
    (response) => response.json(),
  );

  const json = await response;

  if (json?.token === false) {
    store.dispatch(singOut());
    return {
      success: false,
    };
  }

  return json;
};

export const updateRole = async (user, roleId, userData) => {
  const baseApi = process.env.REACT_APP_API_BASE;

  const options = {
    method: "POST", // specifying the HTTP method
    headers: {
      "Content-Type": "application/json", // specifying the Content-Type of the request body
      Authorization: `Bearer ${user?.token}`,
    },
    body: JSON.stringify({
      roleId,
      updateFields: userData,
    }),
  };

  const response = await fetch(`${baseApi}roles/update`, options).then(
    (response) => response.json(),
  );

  const json = await response;

  if (json?.token === false) {
    store.dispatch(singOut());
    return {
      role: {},
    };
  }

  return json;
};

export const GetListRoleModulePermissionsByCompanyService = async (params) => {
  let reply = { ok: false };

  try {
    reply = await connector.get(
      controller,
      "GetListRoleModulePermissionsByCompany",
      params,
    );
  } catch (error) {
    console.log(error);
    reply = { ok: false };
  }

  return reply;
};

export const GetListPermissionsRoleModulePermissionsByCompanyService = async (
  params,
) => {
  let reply = { ok: false };

  try {
    reply = await connector.get(
      controller,
      "GetListPermissionsRoleModulePermissionsByCompany",
      params,
    );
  } catch (error) {
    console.log(error);
    reply = { ok: false };
  }

  return reply;
};

export const SaveRolePermissionsService = async (params) => {
  let reply = { ok: false };

  try {
    reply = await connector.post(controller, "SaveRolePermissions", params);
  } catch (error) {
    console.log(error);
    reply = { ok: false };
  }

  return reply;
};
